import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchRecentUserConversationId,
  fetchConversation,
  sendChatMessage
} from '../../Apis/actions/chat-actions';

import { callFtuComplete } from '../../Apis/actions/signin-actions';

import './Chat.scss';
import classNames from 'classnames';
// import Input from "../Input/Input.js";
// import { validateInput } from "../../utils/utils";

import { useNavigate } from 'react-router-dom';

import useDetectDevice from '../../functionality/Hooks/detectDevice';

import TextareaAutosize from '@mui/material/TextareaAutosize';

import Icon from '../atoms/Icon/Icon';
import Modal from '../atoms/Modal/Modal';
import Button from '../atoms/Button/Button';

import Markdown from 'react-markdown';
// import { MathJax, MathJaxContext } from 'better-react-mathjax';
// "better-react-mathjax": "^2.0.3",
import remarkGfm from 'remark-gfm';

import remarkMath from 'remark-math';

export default function Chat({ userEmail, userToken }) {
  const dispatch = useDispatch();

  const isMobile = useDetectDevice(520);
  const { isLoggedin } = useSelector((state) => state.signInReducer);

  const safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
  const navigate = useNavigate();

  const {
    recentConversationId,
    recentConvoLoading,
    conversation,
    // recentConvoErrorMessage,
    // recentConvoError,
    // convoLoading,
    chatLoading,
    completion,
    conversationId
  } = useSelector((state) => state.chatReducer);

  const isFtuComplete =
    JSON.parse(localStorage.getItem('userData'))?.isFtuComplete === undefined
      ? true
      : JSON.parse(localStorage.getItem('userData'))?.isFtuComplete;

  const [inputMessage, setInputMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [mode, setMode] = useState('search'); // 'search' or 'linkedin'

  const [showOkPopup, setShowOkPopup] = useState(false);

  // Fetch recent conversation ID on mount
  useEffect(() => {
    if (userEmail && userToken && isLoggedin) {
      dispatch(fetchRecentUserConversationId(userEmail, userToken));
    }
  }, [dispatch, userEmail, userToken, isLoggedin]);

  // When recentConversationId updates, fetch full conversation
  useEffect(() => {
    if (recentConversationId && userEmail && userToken) {
      dispatch(fetchConversation(recentConversationId, userEmail, userToken));
    }
  }, [dispatch, recentConversationId, userEmail, userToken]);

  // When conversation updates from store
  useEffect(() => {
    if (conversation) {
      setMessages(conversation);
    }
  }, [conversation]);

  // When new reply comes in
  useEffect(() => {
    if (completion && conversationId) {
      setMessages((prev) => [
        ...prev,
        {
          role: 'REPLY',
          message: completion,
          log_time: new Date().toISOString()
        }
      ]);
    }
  }, [completion, conversationId]);

  // to control ftu model
  useEffect(() => {
    if (!isFtuComplete) {
      setShowOkPopup(true);
    }
  }, [isFtuComplete]);

  const handleSend = () => {
    setMode('search');
    if (!inputMessage.trim()) return;

    const newUserMessage = {
      role: 'USER',
      message: inputMessage,
      log_time: new Date().toISOString()
    };

    setMessages((prev) => [...prev, newUserMessage]);
    dispatch(sendChatMessage(inputMessage, conversationId, userEmail, userToken));
    setInputMessage('');
  };

  const handleInputChange = (e) => {
    setInputMessage(e.target.value);
  };

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // useEffect(() => {
  //   newsroomExampleChat.concat(messages);
  // }, [messages]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleKeyUp = (event) => {
    if (event.keyCode === 13 && !event.shiftKey) {
      event.preventDefault();
      if (inputMessage) {
        handleSend();
      }
    }
  };

  const formattedSubject = 'Request for a contact not found in the Search Engine';
  const mailToLink =
    'mailto:bot-user-sending-us-m-aaaaqcwxmgi4evf6kftva3jjou@tmxnews.slack.com?subject=' +
    encodeURIComponent(formattedSubject);

  // const peopleFinderLink = 'https://usetmx.com/contacts';

  const handlePeopleFinderLink = () => {
    navigate('/personsearch');
  };

  function urlTransform(value) {
    // Same as:
    // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
    // But without the `encode` part.
    const tel = value.indexOf('tel');
    const mailto = value.indexOf('mailto');
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');

    if (tel !== -1 || mailto !== -1) {
      // used to allow phone numbers & emails
      return value;
    } else if (
      // If there is no protocol, it’s relative.
      colon === -1 ||
      // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
      (slash !== -1 && colon > slash) ||
      (questionMark !== -1 && colon > questionMark) ||
      (numberSign !== -1 && colon > numberSign) ||
      // It is a protocol, it should be allowed.
      safeProtocol.test(value.slice(0, colon))
    ) {
      return value;
    }

    return '';
  }

  const handleFtuComplete = () => {
    dispatch(callFtuComplete(userEmail, userToken));
    setShowOkPopup(false);
  };

  return (
    <>
      {showOkPopup ? (
        <Modal
          close={() => handleFtuComplete()}
          closeIcon
          customModalWrapper={'tmx-chat__customModalWrapper'}
          contentClassName={'tmx-chat__modal'}
          title="Welcome to TMX Search">
          <div className="tmx-chat__manyResultModalBtnContainer">
            <Button
              className="tmx-chat__manyResultBtn"
              buttonType="blue"
              handleClick={() => {
                handleFtuComplete();
              }}>
              Start Searching
            </Button>
          </div>
        </Modal>
      ) : null}
      <div className="tmx-chat">
        <div
          className={classNames('tmx-chat__title', {
            'tmx-chat__title--hide': isMobile && isLoggedin
          })}>
          {!isMobile && isLoggedin
            ? 'Find any contact. Request any expert.'
            : 'The search engine for contacts.'}
        </div>
        <div className="tmx-chat__content">
          <div className="tmx-chat__messages">
            {messages.map((msg, idx) => (
              <div
                key={idx}
                className={classNames('tmx-chat__message', {
                  'tmx-chat__message--user': msg.role === 'USER',
                  'tmx-chat__message--assistant': msg.role === 'REPLY'
                })}>
                {/* <MathJaxContext> */}
                {/* <MathJax dynamic hideUntilTypeset="every"> */}
                <Markdown urlTransform={urlTransform} remarkPlugins={[remarkMath, remarkGfm]}>
                  {msg.message}
                </Markdown>

                {/* {msg.message} */}
                {/* </MathJax>
              </MathJaxContext> */}
              </div>
            ))}
            {recentConvoLoading && (
              <>
                <div
                  className={classNames('tmx-chat__messageLoading', {
                    'tmx-chat__messageLoading--userLoading': true
                  })}></div>
                <di
                  className={classNames('tmx-chat__messageLoading', {
                    'tmx-chat__messageLoading--assistantLoading': true
                  })}></di>
                <div
                  className={classNames('tmx-chat__messageLoading', {
                    'tmx-chat__messageLoading--userLoading': true
                  })}></div>
                <di
                  className={classNames('tmx-chat__messageLoading', {
                    'tmx-chat__messageLoading--assistantLoading': true
                  })}></di>
              </>
            )}
            {chatLoading && <div class="tmx-chat__loader"></div>}
            {/* {recentConvoErrorMessage === 404 &&
            recentConvoError &&
            messages?.length === 0 && (
              <div
                className={classNames("tmx-chat__message", {
                  "tmx-chat__message--assistant tmx-chat__message--bubble": true,
                })}
              >
                <b>Welcome to your smart TMX chatbot!</b> <br />
                Easily find any contacts you need—just ask. If the results
                aren’t quite right, you can also click the button at the top to
                send a request directly to our team. We’ll manually review it
                and email you the correct information.
              </div>
            )} */}
            <div ref={messagesEndRef} />
          </div>
          <div className="tmx-chat__input">
            <div className="tmx-chat__textAreaContainer">
              <TextareaAutosize
                value={inputMessage}
                onChange={handleInputChange}
                disabled={chatLoading}
                placeholder={
                  chatLoading
                    ? 'Searching for contacts... this might take up to 30 seconds'
                    : mode === 'linkedin'
                    ? 'Enter the LinkedIn profile URL of the person you need to contact'
                    : mode === 'story'
                    ? 'Enter a story URL to find contacts from the story'
                    : 'Who are you trying to contact?'
                }
                className="tmx-chat__textArea"
                maxRows="8"
                onKeyUp={handleKeyUp}></TextareaAutosize>
              <div className="tmx-chat__buttonGroup">
                {!isMobile && (
                  <>
                    <button
                      className={classNames('tmx-chat__toolbarButton', {
                        'tmx-chat__toolbarButton--active': mode === 'search'
                      })}
                      disabled={chatLoading}
                      onClick={() => setMode('search')}>
                      Search
                    </button>

                    <button
                      className={classNames('tmx-chat__toolbarButton', {
                        'tmx-chat__toolbarButton--active': mode === 'linkedin'
                      })}
                      disabled={chatLoading}
                      onClick={() => setMode('linkedin')}>
                      LinkedIn
                    </button>

                    <button
                      className={classNames('tmx-chat__toolbarButton', {
                        'tmx-chat__toolbarButton--active': mode === 'story'
                      })}
                      disabled={chatLoading}
                      onClick={() => setMode('story')}>
                      Story URL
                    </button>

                    <a
                      href={handlePeopleFinderLink}
                      onClick={handlePeopleFinderLink}
                      className="tmx-chat__toolbarButton"
                      target="_blank"
                      rel="noopener noreferrer">
                      Regular Person
                    </a>
                    <a
                      href={mailToLink}
                      className="tmx-chat__toolbarButton"
                      target="_blank"
                      rel="noopener noreferrer">
                      Bad Result
                    </a>
                  </>
                )}
                <button
                  className="tmx-chat__textAreaButton"
                  onClick={handleSend}
                  disabled={chatLoading}>
                  <Icon name="arrow-right" className="tmx-chat__textAreaIcon" size="ginormous" />
                </button>
              </div>
            </div>
            <div className={classNames('tmx-chat__disclaimer')}>
              If result isn't accurate,{' '}
              <a href={mailToLink} className="tmx-chat__disclaimer--link">
                let us know
              </a>{' '}
              and we will send you the right contacts.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
